export const CHECK_USER = "CHECK_USER";
export const ERROR_USER = "ERROR_USER";
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_ERROR = "REGISTER_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const RESET_LOADING = "RESET_LOADING";
